<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">账号：</div>
        <el-input v-model="filters.xbid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">名字：</div>
        <el-input v-model="filters.nickname" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户UID：</div>
        <el-input v-model="filters.uid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">跟单人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">姓名：</div>
        <el-input v-model="filters.real_name" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
    </div>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker v-model="filters.dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-radio-group v-model="filters.status">
          <div class="dib mr-20">
            <el-radio :label="item.value" v-for="(item, index) in statusList" :key="index">{{item.name}}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="uid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column label="昵称" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adUserDetail', query: {uid: scope.row.uid}}">{{scope.row.nickname}}</router-link>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="nickname" label="头像" width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.headimgurl" width="60" height="60">
        </template>
      </el-table-column>
      -->
      <el-table-column prop="xbid" label="登陆账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="密码" width="" align="center">
        <template slot-scope="scope">
          <el-popover placement="top-end" width="100" trigger="click" :content="scope.row.password">
            <el-button slot="reference" type="text">点击显示</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="opid" label="跟单人" width="100" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.opid" size="small" @change="changeUserinfo(scope.$index, 1)">
            <el-option v-for="item in operLists.slice(1)" :key="item.opid" :label="item.nickname" :value="item.opid"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="corporate" label="是否开启对公" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.corporate == 0">否</div>
          <div v-if="scope.row.corporate == 1">是</div>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="支付宝账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="real_name" label="姓名" width="" align="center">
      </el-table-column>
      <el-table-column prop="order_num" label="总订单" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adOrder', query: {uid: scope.row.uid}}">{{scope.row.order_num}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="invalid_num" label="丢单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="run_ocount" label="跟单中订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="run_payment" label="跟单中金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="run_commission" label="跟单中佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="income" label="已通过佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_order" label="已打款订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_amount" label="已打款佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" class="blue-small-btn" @click="changeUserinfo(scope.$index, 2)">正常</div>
          <div v-if="scope.row.status == 0" class="red-small-btn" @click="changeUserinfo(scope.$index, 2)">封杀</div>
          <div v-if="scope.row.status == 2" class="red-small-btn" style="width: 60px">禁止兑换</div>
          <div v-if="scope.row.status == 3" class="red-small-btn">可疑</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <div @click="editDetail(scope.$index)">
              <i class="el-icon-edit"></i>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="用户信息编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户ID:</div>
            <el-input class="dataForm__input" v-model="detail.uid" size="mini" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">跟单人:</div>
            <el-select v-model="detail.opid" size="small">
              <el-option v-for="item in operLists.slice(1)" :key="item.opid" :label="item.nickname" :value="item.opid"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">对公开启:</div>
            <el-radio-group class="dataForm__input" v-model="detail.corporate">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">对公账户名称:</div>
            <el-input class="dataForm__input" v-model="detail.corp_account_name" size="mini"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">对公银行账号:</div>
            <el-input class="dataForm__input" v-model="detail.corp_bank_account_no" size="mini"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">对公开户行名称:</div>
            <el-input class="dataForm__input" v-model="detail.corp_bank_name" size="mini"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">开户行联行号:</div>
            <el-input class="dataForm__input" v-model="detail.corp_bank_branch_no" size="mini"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">快递手机号码</div>
            <el-input type="textarea" :rows="2" v-model="detail.express_mobiles" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">显示折扣:</div>
            <el-radio-group class="dataForm__input" v-model="detail.show_discount">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detail.status">
              <div class="dib mr-20">
                <el-radio :label="0">封杀</el-radio>
                <el-radio :label="1">正常</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="flex mt-30">
            <div class="blue-large-btn mr-20" @click="saveDetail">保存</div>
            <div class="gray-large-btn" @click="detailDialog = false">取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {adUserLists, userEdit} from '../../../api/api'
import operSelect from '../../../components/data-select/operSelect.vue'
export default {
  name: 'adUserList',
  mixins: [mixinList],
  components: {
    operSelect
  },
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '正常',
          value: 1
        },
        {
          name: '封杀',
          value: 0
        }
      ],
      lists: [],
      operLists: [],
      detailDialog: false,
      detail: {
        uid: 0,
        opid: 0,
        corporate: 0,
        corp_account_name : '',
        corp_bank_account_no: '',
        corp_bank_name: '',
        corp_bank_branch_no: '',
        express_mobiles: '',
        show_discount: 0,
        status: 1
      },
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        nickname: '',
        uid: '',
        opid: '',
        xbid: '',
        real_name: '',
        dateTime: '',
        start_time: '',
        end_time: '',
        status: ''
      }
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.nickname !== '') {
        params.nickname = filters.nickname
      }
      if (filters.uid !== '') {
        params.uid = filters.uid
      }
      if (filters.opid !== '') {
        params.opid = filters.opid
      }
      if (filters.xbid !== '') {
        params.xbid = filters.xbid
      }
      if (filters.real_name !== '') {
        params.real_name = filters.real_name
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      this.listLoading = true
      adUserLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    changeUserinfo (index, oper) {
      let status = this.lists[index].status
      let uid = this.lists[index].uid
      let opid = this.lists[index].opid

      if (oper === 2) {
        status = this.lists[index].status === 1 ? 0 : 1
      }

      let params = {
        status: status,
        uid: uid,
        opid: opid
      }
      userEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    saveDetail () {
      let params = util.cloneObj(this.detail)

      userEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.detailDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    dateTimeChange () {
      if (this.filters.dateTime) {
        this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
        this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
      } else {
        this.filters.start_time = ''
        this.filters.end_time = ''
      }
    }
  },
  mounted () {
    this.getList()
  },
  watch: {
    'filters.dateTime': 'dateTimeChange',
    'filters.opid': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adUserList.vue